import Dashboard from '../../assets/images/json/Home.json';
import Home from '../../assets/images/json/Home.json';
import BankAccount from './Bankacounts.json';
import Transaction from '../../assets/images/json/Home.json';
import Confetti from './Confetti.json';
import Bills from '../../assets/images/json/Bill.json';
import Vendor from '../../assets/images/json/Vendor.json';
import Invoice from '../../assets/images/json/Invoice.json';
import Failure from '../../assets/images/json/failure.json';
import Success from "../../assets/images/json/success.json"
// import Invoice from '../../assets/images/w-icon-invoice.svg';
// import Vendor from '../../assets/images/w-icon-vendors.svg';
// import HomeNew from '../../assets/images/w-icon-home.svg';

export const getImageJSON = type => {
  const path = {
    'home-active': Home,
    'analytics-active': Dashboard,
    'bankaccount-active': BankAccount,
    invoice: Invoice,
    vendor: Vendor,
    confetti: Confetti,
    'bills-active': Bills,
    failure: Failure,
    success: Success
  };
  return path[type];
};
